import { render, staticRenderFns } from "./CoveragesMonthView.vue?vue&type=template&id=d851544e&scoped=true"
import script from "./CoveragesMonthView.vue?vue&type=script&lang=js"
export * from "./CoveragesMonthView.vue?vue&type=script&lang=js"
import style0 from "./CoveragesMonthView.vue?vue&type=style&index=0&id=d851544e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d851544e",
  null
  
)

export default component.exports